
import locale from 'element-ui/lib/locale/lang/ja'

export default {
  loadText: 'いらっしゃいませ',
  title: '寧波今日食品有限公司',
  nav: {
    about: '今日の世界',
    products: '今日の王国',
    medias: '今日のトップ記事',
    contact: 'お問い合わせ',
    base: '生産拠点',
    human: '人事'
  },
  seaTitle: '新鮮な生活は今日から始まる',
  homeTitle1: {
    title: '今日の王国',
    sub: 'PRODUCTS'
  },
  homeTitle2: {
    title: '今日の見出し',
    sub: 'NEWS'
  },
  home: {
    deep: {
      title1: '今日が心を尽くし',
      title2: '国際なブランドを作る',
      title3: '百年の基業を鋳造',
      content: '寧波今日食品有限公司には2000年に設立、中国での最大のマグロを加工工場。冷凍食品、缶詰、FD食品、海洋生化学製品を主とする総合的な食品加工企業。<br>世界各地の人々のために豊かで多様な生態グリーン、健康栄養食品を提供し、品質生活をリードし、世界の食品業界の有名なブランドに向かって前進します。<br>...&nbsp;...',
      ul: [
        '国家級農業産業化の先導企業',
        '国家級の農産物加工模範企業',
        '浙江省の農業先端企業',
        '寧波市輸出食品リーダー企業'
      ],
      count: [
        '従業員数',
        '工場の敷地',
        '建築面積',
        'マグロの年間処理能力',
        '2019年1月のデータ統計'
      ]
    },
    Island: {
      text1: 'おいしい海の幸をどうのように作る',
      text2: 'プロの漁獲チーム',
      text3: '今日食品有限会社には大洋世家に頼って資源を漁って、すでに魚群の種類の範囲を捕って太平洋、インド洋と大西洋の西南の海域まで拡張して、遠洋の漁獲実力は国内の一流のレベルに位置します！'
    },
    what: {
      title: '海からの贈り物、美味しさは舌先につきる',
      sub: 'まぐろの告白',
      info: 'マグロは「海洋マラソン」の選手です。私も美味しい栄養源です。なぜ? 肉の質は新鮮で柔らかくて美味しいです。汚染がなくて、蛋白質の含有量は20%に達します。脂肪の含有量はとても低いです。栄養価が高く、不飽和脂肪酸、DHA、EPAが豊富で、ビタミン、豊富な鉄、カリウム、カルシウム、マグネシウム、ヨードなど多くのミネラルと微量元素を含んでいます。女性のダイエットや美容には絶品です。新鮮で美味しいし、栄養も美味しいし、欧米、日本、オーストラリアなどのお客さんに愛されています。生態の海、健康や美味しいのものはすべて「私」から来ています。'
    }
  },
  about: {
    menu: {
      about: '会社概要',
      story: 'ブランド物语',
      movie: 'イメージが広い',
      honor: '資格名誉',
      history: '開発の歴史'
    },
    base: {
      title: '中国最大のマグロ加工工場です',
      text: '寧波今日食品有限公司には2000年に設立、中国での最大のマグロを加工工場 。 冷凍食品、缶詰、FD食品、海洋生化学製品を主とする総合的な食品加工企業.<br>寧波今日食品有限公司は浙江省寧波渓ロにある。工場は、従業員1000人あまり、敷地面積4500０平米，建築面積30000平米、4000トンの冷凍庫持っています 、年間マグロ加工50000トンです。浙江省の農業先端企業、寧波の輸出食品先導企業です',
      info: [
        '会社は国際食品業界の発展の潮流に従って、状況を調べて、挑戦を迎えて、マグロの高価値化加工と副産物の総合利用を絶えず昇格させて、次第にマグロの精製した魚油、降糖多ペプチドなどの海洋生物活性物質の産業化を実現します。戦略の角度から再び海洋経済とマグロ産業を配置して拡張して、生物医薬と生命科学の領域で絶えない探求と発展。',
        '世界中の人々ために、健康栄养食品を提供することに力を注いで、品質の生活を率いる、食品業界で世界をリードするブランドに向かって前進します'
      ],
      title2: '健康で美味しいと評判を鋳造して天下に渡ります'
    },
    story: {
      banner: '新鮮な生活は今日から始まります',
      text1: {
        title: '縁起-今日',
        sub: '協力を開拓して共に勝つことを求めて全世界を享受します',
        info: '数年来、会社全体は四海に目を向ける広い心で、勇敢に潮に立つ冒険精神を開拓し、苦しみや辛さを堪え忍ぶ実務的品質を開拓し、いつまでも諦めない強い意志で寧波に立脚し、世界を放射し、十分な生産能力は欧米、日本の多くの地域と国家の市場需要を大いに満足させ、良好な国際口を作り上げました碑！'
      },
      text2: {
        title: '健康で美味しいと評判を鋳造して天下に渡ります',
        sub: '協力を開拓して共に勝つことを求めて全世界を享受します',
        info: [
          '製品はアメリカ州、ヨーロッパ、中東、日本、オーストラリアなどの亜市場に輸出して、絶えず新興市場を開拓します。現在、お客様は世界の五大陸三十数カ国と地域に分布しています。業界内の世界的に有名な企業と長期戦略提携関係を樹立しました。完璧な国際販売ネットワークを構築し、栄誉と自信を得ました。',
          '今日は「新鮮な生活が今日から始まる」という理念で、全人類制の健康事業創出に向けて奮闘しています。'
        ]
      }
    },
    movie: {
      banner: 'イメージ大作'
    },
    honor: {
      banner: '新鮮な生活は今日から始まります'
    },
    history: {
      banner: '新鮮な生活は今日から始まります'
    }
  },
  productgroups: {
    banner: '食べ物と愛だけが生きていけない',
    brand: {
      title: '海が赠り物、美味しいあじ',
      detail: '私は「マリンマラソン」の運動選手であり、同時に私も美味しいですなぜそれを言うですか？ <br>私の肉は柔らかい、汚染はされず、タンパク質含有量は20%です、脂肪の含有量は低い、栄養価が高いです不饱和脂肪酸、DHA、EPAを豊富に含んで、<br>、アミノ酸は含んでビタミン、豊富な鉄、カリウム、カルシウム、マグネシウム、ヨードなどの多种のミネラルと微量元素を含んで、女性はダイエット、美容食品です!新鲜な美味しさと栄养のよさ、欧米や日本、オーストラリア顧客に爱され、<br>现代人にはなかなか手にできない健康的な食べ物です。海の健康な美味しさはすべて「私」から来ます!'
    }
  },
  products: {
    banner: '新鮮な生活は今日から始まります'
  },
  product: {
    head: [
      '品名',
      'ネットウエート',
      '味',
      '包装'
    ]
  },
  medias: {
    banner: 'メディア'
  },
  contact: {
    banner: 'お問い合わせ',
    title: '寧波今日食品有限公司',
    info: [
      '38号、中興東路、渓口、奉化、寧波、中国',
      '郵便番号：315502',
      '電話番号：0086-574-88847563',
      'FAX：0086-574-88845098',
      'http：www.todayfood.com.cn',
      'メールアドレス：todayfood@todayfood.com.cn'
    ],
    content: [
      {
        title: 'メディア相談',
        info: 'メールアドレス：todayfood@todayfood.com.cn'
      },
      {
        title: '商品のお問い合わ',
        info: 'お電話：0086-574-88847563'
      },
      {
        title: 'ブランド保護',
        info: '苦情や提案：0086-574-88847563'
      }
    ]
  },
  human: {
    banner: '天の時は地の利',
    content: {
      title: '21世紀は何が一番重要ですか？',
      sub: '天の時は地の利に如かず、地の利は人の和に如かない',
      text: '徳と才能を兼ね備え，徳を先とする',
      info: '会社の人材観は「徳と才能を兼ね備え、徳を先とする」と位置付けられています。徳があってもなくても大任にはなれません。才能があっても徳がなくても使えません。私達は知識を尊重し、人材を尊重し、会社は全体であると強調しています。「君子は財を愛し、道を取る」というのは会社があなたに要求する最低限の道徳行為規範です。会社に対する忠誠、事業に対する執着は、自分の人柄に対して責任を持つことが、あなたを評価する重要な基準です。'
    },
    title1: '従業員のスタイル',
    title2: '人材募集'
  },
  job: {
    title: '人材募集',
    sub: '天の時は地の利に如かず、地の利は人の和に如かない',
    form: {
      name: '名前:',
      sex: {
        label: '性別:',
        placeholder: '性別を選択してください',
        option: [
          '男の人',
          '女の人'
        ]
      },
      marriage: {
        label: '婚姻:',
        placeholder: '婚姻の状態を選んでください',
        option: [
          '未婚',
          '既婚',
          '離婚する'
        ]
      },
      nation: '民族:',
      age: '年齢:',
      place: '本籍地:',
      edu: {
        label: '教養の程度:',
        placeholder: '文化程度を選んでください',
        option: [
          '専門家',
          '本科以上',
          'その他'
        ]
      },
      school: '学校を卒業する:',
      major: '専門:',
      time: '卒業時間:',
      lang: '外国語のレベル:',
      post: 'ポストに応募する:',
      phone: '連絡電話:',
      desc: '履歴書:',
      submit: '送信:'
    }
  },
  base: {
    banner: '海の味はどう演出しますか？',
    content: {
      title: '一生自慢の仕事にとりくむ',
      sub: '私たちは持続的に成功を収めます',
      info: [
        {
          title: '21世紀のブランド経営からの沈殿物',
          text: '中国の大型マグロ生産基地である寧波今日食品有限公司は2000年に設立され、各種冷凍食品、缶詰食品、真空乾燥食品、海洋生化学製品を主とする総合的な食品輸出加工型企業です。'
        },
        {
          title: 'プロの漁獲チーム',
          text: '様々な包囲網で漁をしたり、延縄で釣ったりする先進的な漁獲方式を採用しています。魚群の種類と漁獲の深さを拡大し、自社輸送船団を通じて適時にマグロを基地に運んで加工して、製品の第一新鮮さを確保します。'
        },
        {
          title: '遠洋の旅',
          text: '今日は大洋の家に頼って資源を漁って、すでに魚の群の種類の範囲を捕って太平洋、インド洋と大西洋の西南の海域まで拡張して、遠洋の漁獲実力は国内の一流のレベルに位置します！'
        },
        {
          title: '収穫を選抜する',
          text: '国際的な基準で自分を要求し、食の安全を第一に考えます。生産過程と食品衛生を厳格に把握し、今日の各製品は生態、緑色の要求に適合することを保証する。'
        },
        {
          title: '輸入設備の効率化',
          text: '設備は製品品質の基本保証です。会社は絶えず生産設備を強化して、デンマーク、アメリカ、タイなどからFDハイテクの生産ライン、マグロの蒸し煮と缶詰めの設備を導入して、全体のプロセスはコンピュータの曲線から全自動で完成を制御して、生産量を高める同時に製品の抜群な品質を確保しました。'
        },
        {
          title: '国際品質基準',
          text: '生産過程はISO 9001：2008品質管理体系とISO 14001：2004環境体系認証を厳格に実行するだけでなく、水製品欧州連合の登録工場と米水産物HACCPの認証工場です。製品の品質はイギリスEFIS検査、QS認証、ユダヤ教OU認証、ハラール認証、イルカ保護組織EI認証を通過します。'
        },
        {
          title: '科学研究が開発を助ける',
          text: '会社は科学研究の投入を非常に重視して、独立した研究開発センターを創立して、20台/セットのテスト分析設備を持って、製品の品質検査と新製品の研究開発に用います。浙江大学、江南大学、寧波大学などの大学、研究機関と共に「寧波市食品資源総合利用、深度加工製品開発と品質安全制御科学技術サービスチーム」を設立し、国内初のマグロ総合加工利用と高値化モデル基地を建設しました。'
        },
        {
          title: '精確な配合',
          text: [
            '選ばれた優良部位は専門家の手を通して、まぐろのそれぞれの特性によって、最も正確な混合と比例制御で配合します。真剣かつ責任感のある態度は、人々の好みを満足させることができます。まろやかで、甘く、バランスがよく、まろやかで、すべてのものがあります。',
            '本のツナ缶詰の生産ライン、12匹のツナヤナギの生産ライン、2匹のサバなどの他の水産物の生産ライン、および4000トン以上の冷凍庫があり、各種類の食品を年間5万トン以上生産しています。'
          ]
        }
      ],
      title2: '隠し味'
    }
  },
  Morebtn1: 'もっと読み込む',
  Morebtn2: '戻る',
  btn1: 'もっと見る',
  btn2: '戻る',
  btn3: '戻る',
  btn4: '速やかに申請する',
  swipe1: '社会公益',
  footerTop: {
    text: '新鮮な生活は今日から始まる'
  },
  footerMap: [{
    id: 0,
    title: '今日の世界',
    list: [{
      id: 0,
      title: '会社概要',
      link: '/#/about'
    }, {
      id: 1,
      title: 'ブランドストーリー',
      link: '/#/story'
    }, {
      id: 2,
      title: 'イメージが広い',
      link: '/#/movie'
    }, {
      id: 3,
      title: '資格名誉',
      link: '/#/honor'
    }, {
      id: 4,
      title: '開発の歴史',
      link: '/#/history'
    }]
  }, {
    id: 1,
    title: '今日の王国',
    list: [{
      id: 0,
      title: 'マグロ缶詰',
      link: '/#/products/88'
    }, {
      id: 1,
      title: 'マグロロイン',
      link: '/#/products/89'
    }, {
      id: 2,
      title: 'べットフード',
      link: '/#/products/90'
    }, {
      id: 3,
      title: '海洋生物製品',
      link: '/#/products/91'
    }, {
      id: 4,
      title: 'フリーズドライ食品',
      link: '/#/products/92'
    }, {
      id: 5,
      title: 'その他商品',
      link: '/#/products/114'
    }]
  }, {
    id: 2,
    title: '生産拠点',
    list: [{
      id: 0,
      title: '生産シーン',
      link: '/#/base'
    }]
  }, {
    id: 3,
    title: '今日のトップ記事',
    list: [{
      id: 0,
      title: '企業ニュース',
      link: '/#/medias/21'
    }, {
      id: 1,
      title: 'メディアフォーカス',
      link: '/#/medias/22'
    }, {
      id: 2,
      title: '業界情報',
      link: '/#/medias/23'
    }]
  }, {
    id: 4,
    title: '人事',
    list: [
      {
        id: 0,
        title: 'タレント戦略',
        link: '/#/human'
      }
      // , {
      //   id: 1,
      //   title: '人才招聘',
      //   link: ''
      // }
      // , {
      //   id: 2,
      //   title: '人才招聘'
      // }
    ]
  }, {
    id: 5,
    title: 'お問い合わせ',
    list: [{
      id: 0,
      title: '連絡先情報',
      link: '/#/contact'
    }]
  }],
  footGroup: {
    name: '今日食品有限公司',
    add: [
      '中国寧波奉化渓口',
      '中興東路38号'
    ]
  },
  footLetter: {
    text1: 'お客様からいただきましたメールは',
    text2: '最短時間で返信します'
  },
  footBottom: {
    text1: '©1992-2021 .todayfood.com。すべての権利予約。浙ICP備19020653号-1  ',
    link: [
      '法的声明',
      '著作権情報',
      'お問い合わせ'
    ],
    text2: '寧波今日食品有限公司すべての権利予約浙ICP備19020653号-1',
    text3: [
      'ウェブサイトの構築：',
      '山地网络'
    ]
  },
  mediasLinkNum: '21',
  mediasMenu: [
    {
      id: 0,
      url: '/medias/21',
      text: '企業の動き'
    },
    {
      id: 1,
      url: '/medias/22',
      text: 'メディアフォーカス'
    },
    {
      id: 2,
      url: '/medias/23',
      text: '業界情報'
    }
  ],
  chooseLang: '言語: 日本語',
  langBox: {
    title: '言語を選択',
    menu: [
      '中国語',
      '英語',
      '日本語'
    ]
  },
  // element-ui
  ...locale
}
